document.addEventListener("DOMContentLoaded", function () {
		const ua = navigator.userAgent;
		if (/CriOS/.test(ua) && /iPhone/.test(ua)) {
			document.body.classList.add("chrome-iphone");
		}
	});